export enum TasksTypes {
    CUSTOM = 'custom',
    PAYMENT = 'payment',
    GANTT = 'gantt',
    SUPPLY_REQUEST = 'supply_request',
}

export interface TaskFilters {
    search: string;
    colors: string[];
    tags: number[];
    projects: number | null;
    estimate: number | null;
    type: TasksTypes[];
    executors: number[];
}

export type PersistedTaskFilters = Omit<TaskFilters, 'search'>;

export type ChangeTaskFilter = <K extends keyof TaskFilters>(
    name: K,
    value: TaskFilters[K]
) => void;

export interface TaskBoardViewState {
    filters: TaskFilters;
    is_sorted: boolean;
    is_show_completed: boolean;
}

export type TaskBoardViewStatePatch = Partial<Omit<TaskBoardViewState, 'filters'>> & {
    filters?: Partial<PersistedTaskFilters>;
};
